import en from '../locales/en.json'
import ar from '../locales/ar.json'

export type Lang = 'en' | 'ar'
export type TranslationKey = keyof typeof en

const DICT = { en, ar } as const

export function t(lang: Lang, key: TranslationKey): string {
  return DICT[lang][key]
}

/** bench-SWITCH-SAYS-WHAT-MOVES.CB-E §1④: fills {slot} placeholders; throws on a missing var. */
export function tf(lang: Lang, key: TranslationKey, vars: Record<string, string | number>): string {
  return t(lang, key).replace(/\{(\w+)\}/g, (_match, slot: string) => {
    if (!(slot in vars)) throw new Error(`tf: missing var '${slot}' for key '${key}'`)
    return String(vars[slot])
  })
}
